import React from 'react';
import { Form, Spinner } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
//import filterFactory from 'react-bootstrap-table2-filter';
import { Constants } from "../../constants";
import axios, { AxiosRequestConfig } from 'axios';
import SiteMenu from "../menu";
import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';



function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

class ViewAccountsTable extends React.Component {

    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            loading: false,
            data: [],
            nextPath: props.location.state.nextPath
        };

        this.loadingSpinner = this.loadingSpinner.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);
    }

    componentDidMount () {
        this.handleTableChange("None", this.state);
    }
    componentDidUpdate(event) {
        if (event.history.location.state && event.location.state.nextPath != event.history.location.state.nextPath) {
            this.setState({ nextPath: event.history.location.state.nextPath });
        }
    }

    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {

        this.setState({
            loading: true
        },
            function () {

                axios.get(`${Constants.apiURL}/api/Payment/accounts`, {
                    params: {
                        username: this.state.user.username
                    }
                }).then(response => {
                    if (response.data) {

                        this.setState(() => ({
                            data: response.data,
                            loading: false
                        }));
                    }
                }).catch((response) => {
                    // ? Show to user that request is failed
                    this.setState({ errors: [response] })
                    this.setState({ loading: false });
                    console.log('request failed', response)
                });
            });
    }

    loadingSpinner() {
        if (this.state.loading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No accounts found.';
        }
    }

    render() {
        const { data, sizePerPage, page } = this.state;
        const columns = [
            {
                dataField: 'accountID',
                text: 'Account #',
                sort:true,
                align: 'center',
                formatExtraData: this.state,
                formatter: (cell, row, props, p) => {
                    return <Link to={{
                        pathname: p.nextPath,
                        state: {
                            user: p.user,
                            account: row
                        }
                    }}> {cell} </Link>
                },
                headerStyle: (colum, colIndex) => {
                    return { width: '80px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'accountName',
                text: 'Account Name',
                sort: true,
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '180px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'billingAddress',
                text: 'Billing Address',
                sort: true,
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '180px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'currentAccountBalance',
                text: 'Account Balance',
                sort: true,
                align: 'center',
                formatter: currencyFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '120px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'overdueBalance',
                text: 'Overdue Balance',
                sort: true,
                align: 'center',
                formatter: currencyFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '120px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            }
        ];
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='accountSelection' />
                <Form.Label className="form-header" style={{ padding: '10px 20px 0px 20px' }}>Please select an account.</Form.Label>

                <BootstrapTable
                    bootstrap4
                    keyField="Id"
                    wrapperClasses="table-responsive account-selection-table"
                    data={data}
                    striped
                    columns={columns}
                    onTableChange={this.handleTableChange}
                    noDataIndication={this.loadingSpinner}
                    hover
                />
            </div>
        );
    }
}
export default ViewAccountsTable;